<template>
  <div>
    <a-row  type="flex" justify="space-between" :gutter="20" >
      <a-col style="min-height: 30px">
          Reputation Status: <span v-if="healthStats != null" :class="healthStats.summary.status"><a-icon :type="healthStats.summary.status==='healthy' ? 'check-circle' : (healthStats.summary.status === 'danger' ? 'close-circle' : 'warning')"/>&nbsp;{{healthStats.summary.status}}</span>
        <a-spin v-else></a-spin>
      </a-col>
    </a-row>
    <a-row v-if="healthStats != null && healthStats.warnings.length" type="flex" justify="space-between" :gutter="20" >
      <a-col>
        <a-popover title="Recent warnings">
          <template #content>
            <p v-for="(warning, i) in healthStats.warnings" :key="i">{{ warning }}</p>
          </template>
          <span style="text-decoration: underline">
            There were warnings recently with reputation status
          </span>
        </a-popover>

      </a-col>
    </a-row>

    <!-- Filtros y Ordenar-->
    <a-row type="flex" justify="space-between" :gutter="20" >
      <a-col :span="24" class="titulo">
        Filtros:
      </a-col>
      <a-col :span="24">
        <a-row type="flex" justify="space-between" :gutter="20" class="filtros">
          <a-col :span="6" style="display: flex;align-items: center;justify-content: space-between;">
            <a-icon type="global" />
            <a-select 
              class="shadowInputs"
              mode="multiple" 
              style="width: calc(100% - 25px);" 
              placeholder="Filtro por País" 
              v-model="filters.pais" 
              allowClear 
              @change="filtrar()"
              optionFilterProp="title">
              <a-select-option v-for="itemPais in PAISES" :key="'pais'+itemPais.id" :value='itemPais.id' :title="itemPais.name">
                <span style="font-size: 20px;margin-right: 5px;">{{itemPais.emoji}}</span>
                <span>{{ itemPais.name }}</span>
              </a-select-option>
            </a-select>
          </a-col>

          <a-col :span="6" style="display: flex;align-items: center;justify-content: space-between;">
            <a-icon type="share-alt" />
            <a-select 
              mode="multiple" 
              class="shadowInputs"
              style="width: calc(100% - 25px);" 
              placeholder="Filtro por Categoría" 
              v-model="filters.categoria" 
              @change="filtrar()"
              allowClear>
              <a-select-option v-for="itemCategoria in CATEGORIAS" :key="'categoria_'+itemCategoria.id" :value='itemCategoria.id' v-if="itemCategoria.id > 1">
                {{ itemCategoria.name }}
              </a-select-option>
            </a-select>
          </a-col>

          <a-col :span="6" style="display: flex;align-items: center;justify-content: space-between;">
            <a-icon type="tags" />
            <a-select 
              mode="multiple"
              class="shadowInputs"
              style="width: calc(100% - 25px);" 
              placeholder="Filtro por Estado" 
              v-model="filters.estado" 
              allowClear 
              @change="filtrar()"
              optionFilterProp="title">
              <a-select-option v-for="itemEstado in ESTADOS" :key="'estado'+itemEstado.key" :value='itemEstado.key' :title="itemEstado.nombre">{{ itemEstado.nombre }}</a-select-option>
            </a-select>
          </a-col>

          <a-col :span="6" style="display: flex;align-items: center;justify-content: space-between;">
            <a-icon type="user" />
            <a-select 
              mode="multiple"
              class="shadowInputs"
              style="width: calc(100% - 25px);" 
              placeholder="Filtro por Lista" 
              v-model="filters.lista" 
              allowClear
              @change="filtrar()"
              optionFilterProp="title">
              <a-select-option v-for="itemLista in listas" :key="'lista_'+itemLista.id" :value='itemLista.id' :title="itemLista.nombre">{{ itemLista.nombre }}</a-select-option>
            </a-select>
          </a-col>

          <a-col :span="12" style="display: flex;align-items: center;justify-content: space-between; margin-top: 10px">
            <a-icon type="clock-circle" />
            <a-range-picker
              class="shadowInputs"
              style="width: calc(100% - 25px);" 
              :placeholder="['Desde', 'Hasta']"  
              v-model="filters.periodo" 
              @change="filtrar()"
              format="D MMMM YYYY"
              :allowClear="tab_activa != '2'"
            />
          </a-col> 

          <a-col :span="6" style="display: flex;align-items: center;justify-content: space-between; margin-top: 10px">
            <a-icon type="search" />
            <a-input
              class="shadowInputs"
              style="width: calc(100% - 25px)"
              v-model="filters.textUTM"
              placeholder="Buscar por UTM Campaign"
              @change="filtrar(true)"
              />
          </a-col>

          <a-col :span="6" style="display: flex;align-items: center;justify-content: space-between; margin-top: 10px">
            <a-icon type="search" />
            <a-input
              class="shadowInputs"
              style="width: calc(100% - 25px)"
              v-model="filters.nombre"
              placeholder="Buscar por Nombre"
              @change="filtrar(true)"
              />
          </a-col>

          <a-col  :span="6" />
        </a-row>
      </a-col>
    </a-row>

    <!-- Resumen -->
    <a-row type="flex" justify="space-between" align="middle" style="margin-top: 20px;">

      <a-col :span="24" class="titulo">
        Resumen:
      </a-col>
      <a-col :span="24">
        <a-row type="flex" justify="space-between" align="middle" :gutter="20" class="resumen">
          <a-col :span="4">
            <a-card :bordered='false' class="shadow">
              <detailHover titulo="Cantidad de mails" :valor="format_number(resumen.cantidad)" />
            </a-card>
          </a-col>
          <a-col :span="4">
            <a-card :bordered='false' class="shadow">
              <detailHover titulo="#Personas" :valor="format_number(resumen.personas)" />
            </a-card>
          </a-col>
          <a-col :span="4">
            <a-card :bordered='false' class="shadow">
              <detailHover titulo="#Abiertos" :valor="format_number(resumen.abiertos)" :hover="porcentaje(resumen.abiertos, resumen.personas)" />
            </a-card>
          </a-col>
          <a-col :span="4">
            <a-card :bordered='false' class="shadow">
              <detailHover titulo="#Clicks" :valor="format_number(resumen.clicks)" :hover="porcentaje(resumen.clicks, resumen.personas)"/>
            </a-card>
          </a-col>
          <a-col :span="4">
            <a-card :bordered='false' class="shadow">
              <detailHover titulo="#Conversiones" :valor="format_number(resumen.conversiones)" :hover="porcentaje(resumen.conversiones, resumen.personas)"/>
            </a-card>
          </a-col>
          <a-col :span="4">
            <a-card :bordered='false' class="shadow">
              <detailHover titulo="Costo" :valor="'USD '+format_number(resumen.costo)" :hover="promedio(resumen.costo,resumen.personas)" />
            </a-card>
          </a-col>
        </a-row>
      </a-col>
    </a-row>

    <a-row type="flex" justify="space-between" style="margin-top: 20px;" :gutter="20">
      
      <!-- tabs -->
      <a-col :span="16" class="titulo" style="margin-bottom: 20px">
        <span @click="cargar_listado()" :class="(tab_activa != '1') ? 'tabNoSelect tab' : 'tab' ">Listado</span>
        <span @click="cargar_calendario()" :class="(tab_activa != '2') ? 'tabNoSelect tab' : 'tab' ">Calendario</span>
      </a-col>

      <!-- botones de header -->
      <a-col :span="4" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px" v-if="tab_activa == '1'">
        <a-icon :type="orden.asendente ? 'arrow-up' : 'arrow-down'" @click="orden.asendente = !orden.asendente; filtrar();"/>
        <a-select 
          style="width: calc(100% - 25px);" 
          placeholder="Ordenar" 
          v-model="orden.valor" 
          @change="filtrar()"
          allowClear
          class="shadowInputs">
          <a-select-option value="fecha">Fecha de Envio</a-select-option>
          <a-select-option value="personas"># Personas</a-select-option>
          <a-select-option value="abiertos"># Abiertos</a-select-option>
          <a-select-option value="clicks"># Clicks</a-select-option>
          <a-select-option value="conversiones"># Conversiones</a-select-option>
          <a-select-option value="costo">$ Costo</a-select-option>
          <a-select-option value="porcentaje_abiertos">% Abiertos</a-select-option>
          <a-select-option value="porcentaje_clicks">% Clicks</a-select-option>
          <a-select-option value="porcentaje_conversiones">% Conversiones</a-select-option>
        </a-select>
      </a-col>
      <a-col style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px" v-if="tab_activa == '2'">
        <a-button-group>
          <a-button type="primary" @click="avanzar_mes(true)" >
            <a-icon type="left" /> {{ nombre_mes(anterior_mes(filters.periodo[1])) }}
          </a-button>
          <a-button type="primary" @click="avanzar_mes(false)" >
            {{ nombre_mes(siguiente_mes(filters.periodo[1])) }} <a-icon type="right" />
          </a-button>
        </a-button-group>
      </a-col>

      <!-- contenido tabs -->
      <a-col :span="24">
        <a-tabs v-model="tab_activa" :tabBarStyle="{ display: 'none'}">

          <!-- Listado -->
          <a-tab-pane key="1" tab="">
            <a-row>
              <a-spin :spinning="loadingSearch">
                <itemMail v-for="mailing in mailings" :key="mailing.id" :mailing="mailing" :mailings="mailings" :listas="listas"/>
              </a-spin>
              <a-pagination v-model="paginaActual" :total="parseInt(resumen.cantidad)" @change="cambiarPagina()" hideOnSinglePage />
              <span v-if="mailings.length <= 0" style="margin: 30px 0px; display: block;">No se encontraron resultados para los filtros solicitados.</span>
            </a-row>
          </a-tab-pane>

          <!-- Calendario -->
          <a-tab-pane key="2" tab="">
            <a-row type="flex" justify="center" align="middle" class="calendar shadow">
              <a-col :span="24" class="titulo" style="margin: 10px 0px 20px; padding: 0px 20px; text-align: right; font-weight: 200; font-size: 30px;">{{ nombre_mes_anio(filters.periodo[1]) }}</a-col>
              <a-col :span="24">
                <a-calendar 
                  v-if="tab_activa == '2'" 
                  mode="month" 
                  v-model= filters.periodo[1]
                  >
                  <ul class="events" slot="dateCellRender" slot-scope="dia">
                    <li v-for="itemCalendar in getListData(dia)" :key="itemCalendar.content">
                      <calendarTag :mailing="itemCalendar" :mailings="mailings" :listas="listas"/>
                    </li>
                  </ul>
                </a-calendar>
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </a-col>
    </a-row>
  </div>
</template>

<script>

import moment from 'moment'
import itemMail from '../components/ItemMail.vue'
import detailHover from '../components/DetailHover.vue'
import calendarTag from '../components/CalendarTag.vue'
import utils from '../service/service.js'
import categories from "@/service/categories";
import countries from "@/service/countries";

moment.locale('ES');

export default {
  name: 'panel',
  props: ["titulo","valor","hover","filtro_pais", "filtro_categoria", "filtro_estado","filtro_lista", "filtro_periodo", "filtro_textUTM", "filtro_order", "filtro_dir" ],
  components: {
    calendarTag,
    itemMail,
    detailHover,

  },
  mixins:[utils, categories, countries],
  data(){ 
    return {
      listas:[],
      resumen:{},
      templates: [
        {id:1, nombre:'template_evento_proptech', html: '<div style="background:blue; margin: 0 auto; padding:40px"></div>'},
        {id:2, nombre:'template_evento_asuncion_invierte', html: '<div style="background:green; margin: 0 auto; padding:40px"></div>'},
        {id:3, nombre:'template_ventas_bo', html: '<div style="background: black; margin: 0 auto; padding:40px"></div>'},
        {id:4, nombre:'template_alquiler_y_ventas', html: '<div style="background:yellow; margin: 0 auto; padding:40px"></div>'},
        {id:5, nombre:'template_cambio_de_precio', html: '<div style="background:red; margin: 0 auto; padding:40px"></div>'},
        {id:6, nombre:'exclusivo-ventura-boulevard', html: '<div style="background:red; margin: 0 auto; padding:40px"></div>'},
      ],
      mailings : [],
      filters: {
        pais: [],
        categoria: [],
        estado: [],
        lista:[],
        periodo: [],
        textUTM: '',
        limit: 3,
        offset: 0,
        nombre: '',
      },
      orden:{
        asendente: false,
        valor: undefined,
      },
      paginaActual: 1,
      tab_activa: '1',
      loadingSearch: false,
      debounceSearchTimer: null,
      healthStats: null
    }
  },
  methods: {
    nombre_mes_anio(fecha){
      return moment(fecha, 'DD-MM-YYYY').format('MMMM, YYYY', 'es');
    },
    nombre_mes(fecha){
      return moment(fecha, 'DD-MM-YYYY').format('MMMM', 'es');
    },
    siguiente_mes(fecha){
      var fecha_copia = fecha.clone();
      return fecha_copia.add(1, 'months');
    },
    anterior_mes(fecha){
      var fecha_copia = fecha.clone();
      return fecha_copia.subtract(1, 'months');
    },
    avanzar_mes(atras){
      var $this = this;
      var fecha0_copia = this.filters.periodo[1].clone();
      var fecha1_copia = this.filters.periodo[1].clone();
      if (atras) {
        fecha0_copia.subtract(1, 'months')
        fecha1_copia.subtract(1, 'months');
        this.filters.periodo = [fecha0_copia.startOf('month'), fecha1_copia.endOf("month")];
      }else{
        fecha0_copia.add(1, 'months');
        fecha1_copia.add(1, 'months');
        this.filters.periodo = [fecha0_copia.startOf('month'), fecha1_copia.endOf("month")];
      }
      $this.filters = {...$this.filters, ...{
        periodo : $this.filters.periodo
      }};
      this.filtrar();
    },
    getListData(dia) { //carga mails por dia
      let listData = [...this.mailings];
      listData = listData.filter(function(mailing){
       return moment(mailing.fecha_envio, 'YYYY-MM-DD').isSame(dia, 'day');
      });
      return listData;
    },
    cargar_calendario(){
      if( this.filters.periodo <= 0 ){
        var hoy = moment();
        var mes_atras = moment().subtract(1, 'months');
        this.filters.periodo = [mes_atras ,hoy];
      }
      var fecha0_copia = this.filters.periodo[1].clone();
      var fecha1_copia = this.filters.periodo[1].clone();
      this.filters.periodo = [fecha0_copia.startOf('month'), fecha1_copia.endOf("month")];
      delete this.filters.limit; // capaz hay que cambiar esta cantidad, lo puse como aprox de cuantos mails se mandan en un mail
      delete this.filters.offset ;
      this.$root.$router.push({
          path: '/panel/calendario', 
          query: this.$route.query,
      });
      this.filtrar();
      this.tab_activa = '2'
    },
    cargar_listado(){
      this.filters['limit'] = 10; // en el listado siempre se muestran de a 10
      this.filters['offset'] = 0;
      this.$root.$router.push({
          path: '/panel/listado', 
          query: this.$route.query,
      });
      this.filtrar();
      this.tab_activa = '1'
    },
    promedio(costo, personas){
      if(personas > 0){
        return 'USD '+ (costo / personas).toFixed(2);
      }else
        return '-';
    },
    porcentaje(cantidad, total){ 
      if(total>0){
        cantidad = parseInt(cantidad);
        total = parseInt(total);
        var resultado = ((cantidad / total) * 100).toFixed(2);
        return resultado + '%';
      }else 
        return '-'
    },

    cambiarPagina(){
      var $this = this;
      setTimeout(function(){
        $this.filters['offset'] = ($this.paginaActual * $this.filters['limit']) - $this.filters['limit'];
        $this.filters = {...$this.filters, ...{
          offset : $this.filters.offset
          
        }};
        
        $this.filtrar();
      }, 100);
    },
    async filtrar (debounce = false) {
      if(this.debounceSearchTimer !== null) {
        clearTimeout(this.debounceSearchTimer);
      }

      this.loadingSearch = true;
      this.debounceSearchTimer = setTimeout(async () => {
        let filtros = {
          pais: this.filters.pais,
          categoryId: this.filters.categoria,
          estado: this.filters.estado,
          lista: this.filters.lista,
          periodo: [],
          textUTM: this.filters.textUTM,
          limit: this.filters.limit,
          offset: this.filters.offset,
          nombre: this.filters.nombre,
        };
        if (typeof this.orden.valor != 'undefined') filtros['order'] = this.orden.valor;
        if (this.orden.asendente) filtros['dir'] = 'ASC'; else filtros['dir'] = 'DESC';
        if (this.filters['periodo'].length > 0) filtros['periodo'] = [this.filters['periodo'][0].format('YYYY-MM-DD'), this.filters['periodo'][1].format('YYYY-MM-DD')];


        const {data} = await this.sendRequest({
          method: 'POST',
          url: 'mailings/list',
          data: {
            filters: filtros
          },
        })
        this.loadingSearch = false;
        this.resumen = data.resumen;
        this.mailings = data.mailings;

        var query = {};
        if (filtros["pais"] != "") query['fp'] = filtros['pais'];
        if (filtros["categoria"] != "") query['fc'] = filtros['categoria'];
        if (filtros["estado"] != "") query['fe'] = filtros['estado'];
        if (filtros["lista"] != "") query['fl'] = filtros['lista'];
        if (filtros["periodo"] != "") query['fpe'] = filtros['periodo'];
        if (filtros["textUTM"] != "") query['ft'] = filtros['textUTM'];
        if (filtros["nombre"] != "") query['fn'] = filtros['nombre'];
        if (typeof filtros['order'] != 'undefined') query['order'] = filtros['order'];
        if (typeof filtros['dir'] != 'undefined') query['dir'] = filtros['dir'];
        this.$root.$router.push({
          path: this.$route.params.tab,
          query: query,
        });
      }, debounce ? 800 : 0)
    },
    async getListas(){
      const { data } = await this.sendRequest({
          method: 'GET',
          url: 'listas',
      })
      this.listas = data;
    },
    getTemplates(){

    },

    async getHealthStats() {
      const {data} = await this.sendRequest({
        method: 'GET',
        url: 'health/stats',
      })

      this.healthStats = data
    }
  },
  mounted: function(){
    var $this = this;

    this.getListas();
    this.getTemplates();
    this.getHealthStats();
    ["filtro_pais", "filtro_categoria", "filtro_estado", "filtro_lista", "filtro_periodo", "filtro_textUTM", "filtro_order", "filtro_dir","filtro_nombre"].forEach(function(filtro){
      if(typeof $this[filtro] != "undefined"){
        if(filtro == "filtro_periodo") $this.filters[filtro.slice(filtro.indexOf('_') + 1)] = [moment($this[filtro][0]), moment($this[filtro][1])];
        else if(filtro == "filtro_pais" || filtro == "filtro_lista"){
          if (typeof $this[filtro] == 'string') {
            var valores = [];
            valores.push(parseInt($this[filtro]));
            $this.filters[filtro.slice(filtro.indexOf('_') + 1)] = valores;
          }
          else{
            var valores = [];
            $this[filtro].forEach(function(num){ 
              num = parseInt(num);
              valores.push(num)
            });
            $this.filters[filtro.slice(filtro.indexOf('_') + 1)] = valores;
          }
        }
        else if(filtro == "filtro_categoria" || filtro == "filtro_estado"){
          if (typeof $this[filtro] == 'string') {
            var valores = [];
            valores.push($this[filtro]);
            $this.filters[filtro.slice(filtro.indexOf('_') + 1)] = valores;
          }
          else{
            var valores = [];
            $this[filtro].forEach(function(num){ 
              valores.push(num)
            });
            $this.filters[filtro.slice(filtro.indexOf('_') + 1)] = valores;
          }
        }
        else if (filtro == 'filtro_order') $this.orden.valor = $this[filtro];
        else if (filtro == 'filtro_dir' && $this[filtro] == 'ASC') $this.orden.asendente = true; //por defecto queda false
        else {
          var nuevosFiltros=[$this[filtro]];
          $this.filters[filtro.slice(filtro.indexOf('_') + 1)] = nuevosFiltros;
        }
      }
    });

    if($this.$route.params.tab == 'calendario') 
      $this.cargar_calendario(); 
    else 
      $this.cargar_listado();
  },
  watch: {
    tab_activa: function() {
      if (this.tab_activa==1){
        this.filters.periodo=[];
      }
    },
  }  
}
</script>

<style scoped>
  .events {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .events .ant-badge-status {
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    font-size: 12px;
  }
  .ant-fullcalendar-header{
    display: none;
  }
  .filtros{
    margin: 10px 0px 20px !important;
  }
  .resumen .ant-card{
    border-radius: 5px;
    margin-bottom: 15px;
  }
  .titulo{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;
  }
  .tab {
    margin-right: 20px;
    border-bottom: 2px solid;
  }
  .titulo .tabNoSelect{
    font-size: 16px;
    opacity: 0.6;
    border-bottom: none;
    cursor: pointer;
  }
  .titulo .tabNoSelect:hover{
    color: #1890ff;
  }
  .shadow {
    box-shadow: 2px 1px 5px -4px;
  }
  .shadowInputs {
    box-shadow: 1px 1px 5px -5px;
  }
  .calendar{
    background-color: white;
    padding: 10px 10px 10px;
    margin-bottom: 10px;
  }
  span.healthy {
    color: green;
  }
  span.danger {
    color: #da3939;
  }
  span.warning {
    color: #c5c514;
  }
</style>